
import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { IFormActions, IFormState, IFormSubscription, useFormActions, useFormState } from "@ngt/forms-core";
import { MouseEvent, useMemo } from "react";

export interface IFormActionButtonProps<T extends object = any> extends Omit<LoadingButtonProps, 'onClick' | 'loading'> {
    onClick: (event: MouseEvent<HTMLButtonElement>, formActions: IFormActions<T, string>) => void;
    loading?: boolean | ((formState: IFormState<T, string>) => boolean);
    loadingSubscription?: Partial<IFormSubscription>;
}

const defaultSubscription = {};

const FormActionButton = <T extends object = any>({
    onClick,
    loading,
    loadingSubscription,
    ...rest
}: IFormActionButtonProps<T>) => {
    const formActions = useFormActions<T, string>();
    const formState = useFormState<T, string>(loading instanceof Function ? loadingSubscription : defaultSubscription);

    const click = useMemo(() => {
        if (!onClick) {
            return;
        }

        return (event: MouseEvent<HTMLButtonElement>) => {
            onClick(event, formActions);
        };
    }, [onClick, formActions]);

    const loadingToUse = useMemo(() => {
        if (loading instanceof Function) {
            return loading(formState);
        }

        return loading;
    }, [loading, formState])

    return (
        <LoadingButton 
            {...rest}
            onClick={click}
            loading={loadingToUse}
        />
    )
};

export default FormActionButton;